import React from 'react';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import recipes from "./Data"
import "react-image-gallery/styles/css/image-gallery.css";
import SingleRecipe from "./SingleRecipe"
import RecipeModal from "./RecipeModal"
import { ClickActionEvent } from '../../util/analytics'
import { Link as MaterialLink } from '@mui/material';
 


const sxHeroContent = { py: 8 };
const sxCardGrid = { pt: 8, pb: 8 };
const sxCard = { height: '100%', display: 'flex', flexDirection: 'column' };
const sxCardHover = { ...sxCard, boxShadow: '0 4px 8px 0 rgba(0,0,255,0.8), 0 6px 20px 0 rgba(0,0,255,0.8)', cursor: 'pointer', opacity: 0.7, transition: '0.2s linear' };


export default function ChefCorner() {
  

  

  const [selectedItem, setSelectedItem] = React.useState('')
  const [open, setOpen] = React.useState(false);
  const [currentItem, setCurrentItem] = React.useState({name:"", ingredients:[], instructions:{english:[], hindi:[]}});

  const MouseOver = (t)  =>{
    setSelectedItem(t)
    
  }

  const MouseOut = (event)  =>{
    setSelectedItem('')
  }



  const handleClickOpen = (item)  => {
    ClickActionEvent("Food " + item.name, 'Food section', 'Food item clicked')
    setCurrentItem({name:item.name, ingredients:item.ingredients, instructions:item.instructions})
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  

  return (
    <React.Fragment>
 
  <div style={{backgroundColor:"#dbf5f0"}}>

        <Box sx={{ ...sxHeroContent, backgroundColor: '#dbf5f0' }}>
          <Container maxWidth="md">
            <Typography component="h1" variant="h3" align="center" color="textPrimary" gutterBottom>
              Chef Corner 👨‍🍳
            </Typography>
              <Typography variant="h6" align="center" color="textSecondary" paragraph>
              Recipes which I have learned to cook while living away from home...
              This may help you to cook in very less time with proper instructions without spending much time on youtube to note and rewatch.
              If you have cooked something before, you don't need youtube, just instructions in 2 minutes and you can save your time. <b/>
              <MaterialLink color="inherit" sx={{ mr: 2, fontSize: '1rem', color: '#0c6170' }} href="recipes">
                Click me to check out all the recipes
              </MaterialLink>
            </Typography>
          </Container>
  </Box>
  <Container sx={sxCardGrid} maxWidth="md">
          
          <Grid container spacing={4}>
            <RecipeModal modalStatus={open}  handleClose={handleClose} name={currentItem.name} ingredients={currentItem.ingredients} instructions={currentItem.instructions}/>
            {recipes.map((item) => {
              if (!['matarPaneer', 'rajma', 'butterChicken'].includes(item.key)) return null;
              return (
                <Grid item key={item.id} xs={12} sm={6} md={4}>
                  <Card onClick={() => handleClickOpen(item)} sx={item.name === selectedItem ? sxCardHover : sxCard} onMouseOver={() => MouseOver(item.name)} onMouseOut={MouseOut}>
                    <SingleRecipe name={item.name} id={item.id} noIngredients={item.ingredients.length} image={item.image} description={item.description} />
                  </Card>
                </Grid>
              );
            })}
          </Grid>
          <MaterialLink color="inherit" sx={{ mr: 2, fontSize: '1rem' }} href="recipes">
            Click me to check out all the recipes
          </MaterialLink>
        </Container>
      </div>
 
    </React.Fragment>
  );
}
